import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import SearchFilter from "components/search/SearchFilter";
import TeamCard from "./TeamCard";
import PopupButton from "components/button/PopupButton";
import ClientTeamForm from "./ClientTeamForm";
import { 
    getClientTeamList
} from "../../../../../redux/client/clientState";
import {
    Users
} from "lucide-react";

const Teams = ({ 
    clientId 
}) => {
    const dispatch = useDispatch();
    const recordList = useSelector((state) => state.client.clientTeamList?.items);
    const pagination = useSelector((state) => state.client.clientTeamList?.pagination);
    const filters = useSelector((state) => state.client.clientTeamList?.filters);
    const requesting = useSelector((state) => state.client.clientTeamList?.requesting);
    const error = useSelector((state) => state.client.clientTeamList?.error);

    const doSearch = (filters) => dispatch(getClientTeamList(filters));

    useEffect(() => {
        if (clientId) {
            dispatch(getClientTeamList({paginate: pagination.per_page, clientId}));
        } 
    }, [dispatch, clientId, pagination.per_page]);

    return (
        <Card className="flex flex-col overflow-hidden border rounded-xl p-6">
            <div className="space-y-6">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                        <h2 className="text-2xl sm:text-3xl label-gradient emerald">
                            Teams & Departments
                        </h2>
                        <p className="text-sm text-slate-700 mt-1">
                            {recordList?.length ?? 0} teams  in your organization
                        </p>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex-1 min-w-0 sm:w-[400px]">
                            <SearchFilter
                                placeholder="Search teams..."
                                searchHandler={doSearch} 
                                filters={filters} 
                                pagination={pagination}
                            />
                        </div>
                        <PopupButton 
                            id="add_client_team" 
                            title="Add Client Team" 
                            label="Add" 
                            btnClass="btn-small"
                            useCustomClass={true}
                            modalWidth={600}
                            description="Fill in the details below"
                        >
                            <ClientTeamForm recordId={0} mode="edit" clientId={clientId} />
                        </PopupButton>
                    </div>
                </div>
                <div className="list-3-column gap-6">
                    {recordList && recordList?.length > 0 ? (
                        recordList?.map((team) => {
                            return (
                                <TeamCard
                                    key={team?.cte_id}
                                    team={team}
                                    recordId={team?.cte_id}
                                    clientId={clientId}
                                />
                            );
                        })
                    ) : (
                        <div className="col-span-3">
                            <div className="px-6 pb-6 flex flex-col items-center justify-center py-12 text-center">
                                <Users className="w-16 h-16 mb-4 opacity-50 muted-text" />
                                <h4 className="text-[16px] font-semibold mb-2 title-text">
                                    No Team Found
                                </h4>
                                <p className="text-[13px] max-w-sm muted-text">
                                    Try adjusting your search or filters
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default Teams;